import { buildHeader, buildParagraph, buildNewlines } from "./helpers";

const createSectionAdditionalTeacherSuggestions = (studentData, weeklyPlan) => [
  // Additional Teacher Suggestions Header
  buildHeader(`Additional Teacher Suggestions:`, 3),
  // Additional Teacher Suggestions Table
  buildParagraph(`[TODO] Additional teacher suggestions table`, {
    italics: true,
  }),
  ...buildNewlines(2),
];

export default createSectionAdditionalTeacherSuggestions;
